export function processFile(file) {
    return JSON.parse(file.content);
}
